import { baseFields, FormModel } from '../index'

export function getFormModelKeys(): (keyof FormModel)[] {
  return [...baseFields, 'discount', 'perceivedValue', 'images', 'url']
}
